/*********************************************************************
**********************************************************************
Variables
**********************************************************************
*********************************************************************/
const cssVar = {
	colorPrimary200: '#4945be', //Brand Color
	colorPrimary900: '#454298', //Brand Color Dark
	colorPrimary400: '#c9c7ff', //Brand Color light purple
	colorPrimary300: '#f8f8ff',
	colorPrimary100: '#ededfb',
	colorSecondary900: '#3cb500', //Green Shades
	colorSecondary500: '#59b624',
	colorSecondary200: '#53d300',
	colorSecondary400: '#d1fecc',
	colorTypeTertiary: '#969696',
	colorSurePoint200: '#ff2e6f', //Pink Shades
	colorSurePoint400: '#ffc2d5', //Pink Shades
	colorError: '#d3445e', //Pink Shades
	colorGiveSure: '#f7b500', //Yellow Shade
	colorBlack: '#000000',
	colorTypePrimary: '#333333',
	colorTypeSecondary: '#666666',
	colorWhite: '#ffffff',
	colorBorder: '#e0e0e0',
	colorBorderSecondary: '#ececfe',
	colorRed: '#e80101',
	colorBorderCard: '#f2f2f2',
	colorPeriwinkleGray: '#f2f2f2',
	colorPurple: '#f0f0fc',
	colorPurpleLight: '#dfddfd',
	colorPeppermint: '#DDF3DD',
	colorRoyalBlue: '#5f5bde',
	colorGovernorBay: '#3733A5',
	colorPerfume: '#BAB7F9',
	colorParadiso: '#388492',
	colorLima: '#3EDC2C',
	colorParadiso2: '#2F6F7B',
	colorLoader: 'rgba(158,158,158,0.35)',
	colorGrey: '#6c757d',


	// Revisit these after final color palette
	colorBorder1: '#333548',
	colorBorder2: '#575757',
	colorBorder3: '#efefef',
	color2: '#111425',
	color3: '#282828',
	color4: '#969696',
	color5: '#f1f1f1',
	color6: '#f3f3f3',
	color7: '#f8f8f8',
	color8: '#f1f1fa',
	colorLightOrange: '#fffbf2',
	colorLightOrange200: '#fef7e6',
	color9: '#fff4f8',
	color10: '#f3e6eb',
	color11: '#efffef',
	color12: '#e4f4e4',
	color13: '#f6f6f6',
	color14: '#f2ffea',
	color15: '#eeeeee',
	color16: '#ddd',
	color17: '#545454',
	color18: '#313131',
	color19: '#999999',
	color20: '#cccccc',
	color21: '#43b500',
	color22: '#6c6c6c',
	color23: '#e1e0ff',


	// Fonts
	fontFamily: '"Blinker", sans-serif',
	fontFamilySecondary: '"Exo", sans-serif',
	fontFamilyAllotrope: '"Allotrope", sans-serif',
	h1: '4.8rem',
	h2: '4.0rem',
	h3: '3.2rem',
	h4: '2.8rem',
	h5: '2.4rem',
	h6: '2.0rem',
	fontL: '1.8rem',
	fontM: '1.6rem',
	fontS: '1.4rem',
	fontXs: '1.2rem',
	fontMini: '1.1rem',
	fontMicro: '1.0rem',
	fontCaption: '0.8rem',
	fontEatsurance: '0.85rem',

	// FontWeights
	fontLight: 300,
	fontRegular: 400,
	fontSemibold: 600,
	fontBold: 700,

	// Spacing
	spacingXxxs: '0.4rem',
	spacingXxs: '0.8rem',
	spacingXxss: '1rem',
	spacingXs: '1.2rem',
	spacingS: '1.6rem',
	spacingM: '2.0rem',
	spacingL: '2.4rem',
	spacingXl: '2.8rem',
	spacingXxl: '3.2rem',
	spacingXxxl: '4.0rem',
	spacingPlusSize: '6.0rem',

	// Breakpoints
	mobileXs: '320px',
	tab: '1024px',
	laptop: '1170px',
	desktop: '1440px',
}

export default cssVar;
